if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500), {passive: true});
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false), {passive: true});
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

if (!customElements.get('ml-media-gallery')) {
  customElements.define('ml-media-gallery', class MLMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.drag = {
        x: 0,
        y: 0,
      }
      this.elements = {
        viewer: this.querySelector('[id^="ML_Media_Gallery_Viewer"]'),
        thumbnails: this.querySelectorAll('[id^="ML_Media_Gallery_Thumbnail"]')
      }
      if (!this.elements.thumbnails) return;

      if(this.elements.viewer) {
        const next = this.elements.viewer.querySelector(`[id^="product_media_next_"]`);
        const prev = this.elements.viewer.querySelector(`[id^="product_media_previous_"]`);

        next?.addEventListener('click', () => this.goDirection(true), {passive: true});
        prev?.addEventListener('click', () => this.goDirection(false), {passive: true});
      }

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500), {passive: true});
      this.elements.viewer.addEventListener('dragstart', debounce(this.onDragChanged.bind(this), 500), {passive: true});
      this.elements.viewer.addEventListener('dragover', debounce(this.onDragChanged.bind(this), 500), {passive: true});
      this.elements.viewer.addEventListener('touchstart', debounce(this.onDragChanged.bind(this), 500), {passive: true});
      this.elements.viewer.addEventListener('touchend', debounce(this.onDragChanged.bind(this), 500), {passive: true});
      this.elements.thumbnails.forEach((mediaToSwitch) => {
        mediaToSwitch.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch, mediaToSwitch.dataset.index), {passive: true});
      });

      this.deafultSelectedThumbnail();
    }

    deafultSelectedThumbnail(index = null) {
      const isfeature = this.querySelectorAll('[data-media-isfeatured="true"]');
      if(isfeature?.length > 0 && index == null) {
        const thumb = this.querySelector(".ML_Media_Gallery_Thumbnail_Holder")?.querySelector?.('[data-isfeatured="true"]');
        if(thumb) {
          thumb?.classList?.add("ml_thumb_selected");
          this.index = thumb.dataset.index;
        }
      } else {
        this.elements.thumbnails?.[index || 0]?.classList.add("ml_thumb_selected");
      }
    }

    clearSelectedThumbs() {
      this.elements.thumbnails.forEach((mediaToSwitch) => {
        mediaToSwitch.classList.remove("ml_thumb_selected");
      });
    }

    onSlideChanged(event) {
      console.log(event);
    }

    onDragChanged(event) {
      if(event.type == 'dragstart' || event.type == 'touchstart') {
        this.drag = {
          x: event.x,
          y: event.y
        }
      } else {
        if(Math.abs(this.drag.x - event.x) > 20) {
          if((this.drag.x - event.x) < 0) {
            this.goDirection(false);
          } else {
            this.goDirection(true);
          }
        }
      }
    }

    goDirection(isNext) {
      if(isNext) {
        const newIndex = (this.index + 1) % (this.elements.thumbnails.length);
        this.setActiveMedia(null, newIndex);
      } else {
        const newIndex = (this.index - 1) < 0 ? (this.elements.thumbnails.length - 1) : (this.index - 1);
        this.setActiveMedia(null, newIndex);
      }
    }

    setActiveMedia(el, index) {
      this.index = index;
      this.clearSelectedThumbs();
      this.deafultSelectedThumbnail(index);
      window.pauseAllMedia();
      this.elements.viewer.querySelectorAll(".ml_nested_selection").forEach(
        viewer => {
          viewer.classList.remove("show");
          viewer.classList.remove("hide");
          if(viewer.dataset.mediaIndex == index) {
            viewer.classList.add("show");
            this.playActiveMedia(viewer);
          } else {
            viewer.classList.add("hide");
            viewer.querySelectorAll('iframe').forEach(el => {
              el.contentWindow?.postMessage?.('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
            })
          }
        }
      )
      // Scroll main viewer into view when clicking secondary images
      this.elements.viewer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    playActiveMedia(activeItem, focus = false) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(focus);
    }
  });
}